import type { ReactNode } from 'react'
import { AlertErrorCircle, Retry } from '@/assets/icons'
import { Button } from '@/components/button/Button'

export function WorkProductTableStatus({
  isError,
  onRetry,
  noResultsQuery,
  onClearSearch,
  resourceName,
  children,
}: {
  isError: boolean
  onRetry: () => void
  noResultsQuery: string | null
  onClearSearch: () => void
  resourceName: string
  children: ReactNode
}) {
  if (isError) {
    return (
      <div className="flex h-36 flex-col items-center justify-center gap-3.5 bg-surface-emphasis">
        <div className="flex flex-nowrap items-center gap-1 whitespace-nowrap text-sm text-red-800">
          <AlertErrorCircle className="size-4" />
          <p>Failed to load {resourceName}</p>
        </div>
        <Button onClick={onRetry} trailingIcon={<Retry className="size-4" />} size="sm" variant="tonal" color="neutral" aria-label="Retry">
          Retry
        </Button>
      </div>
    )
  }

  if (noResultsQuery !== null) {
    return (
      <div className="flex h-[68px] items-center justify-center bg-surface-emphasis">
        {/* Capped at 90% of the container so a long query can't push Clear off a narrow screen. */}
        <div className="flex max-w-[90%] items-center gap-3 px-2 py-2">
          <p className="flex min-w-0 items-center text-xs [@container_(min-width:_640px)]:text-sm">
            <span className="shrink-0">
              No <span className="hidden [@container_(min-width:_640px)]:inline">Search </span>Results for &ldquo;
            </span>
            <span className="min-w-0 truncate">{noResultsQuery}</span>
            <span className="shrink-0">&rdquo;</span>
          </p>
          {/* No aria-label: the search field's own × already owns "Clear search", and two controls
              sharing a name on one screen is a trap. */}
          <Button onClick={onClearSearch} size="xs" variant="tonal" color="neutral">
            Clear
          </Button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
